/* eslint 'no-useless-constructor': 'off' */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";
import { LogoutUser } from '../../action/authenticateUser';


class FaciltyMgmntLogout extends Component {
  constructor(props) { super(props); }

  componentWillMount() {
    this.props.LogoutUser();
  }


  render() {
    localStorage.removeItem('previousPage');
    localStorage.removeItem('currentPage');
    localStorage.setItem('jwt', null);
    localStorage.setItem('refreshjwt', null);
    return (<Redirect to="/facilitylogin" />);
  }
}


const mapStateToProps = state => {
  return {
    authentication_response: state.authService
  };
};

const mapDispatchToProps = dispatch => {
  return {
    LogoutUser: () => dispatch(LogoutUser()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FaciltyMgmntLogout);



